import React from 'react';
import { Icon } from 'ui';
import { setQueryString } from 'utils/url';
import { TYPES } from 'constants/config';

const hasParent = parent => parent && parent.id;

const Link = props => <a className="c-brand-blue" {...props} />; // eslint-disable-line

const Title = ({ title, parent, url }) => (
  <div>
    {hasParent(parent) && (
      <Link href={parent.urls.overview}>{parent.title}</Link>
    )}
    {hasParent(parent) && (
      <Icon
        name="chevron_right"
        className="fz-sm c-brand-gray-light ml-8 mr-8"
      />
    )}
    {url ? <Link href={url}>{title}</Link> : <>{title}</>}
  </div>
);

const ContentTitle = ({ title, type, urls = {}, pathId, parent }) => (
  <div className="PerformanceContent-title">
    {type === TYPES.PATH && (
      <Icon name="path" className="PerformanceContent-icon" />
    )}
    {type === TYPES.PATH && (
      <Title title={title} url={urls.overview} parent={parent} />
    )}
    {type === TYPES.LESSON && (
      <Title
        title={title}
        url={setQueryString(
          urls.overview,
          { path_id: pathId },
          { merge: true },
        )}
        parent={parent}
      />
    )}
    {type === TYPES.DEMONSTRATION && <Title title={title} parent={parent} />}
  </div>
);

export default ContentTitle;
